module.exports = __webpack_public_path__ + "static/media/Ellipse252.fd8d554e.png";